import "./index.less";
import ZModle from "../../common/components/z-modal/index";
import jkyForm from "../../common/components/jky-form/index";
import JKYmodalstatic from "./sections/jky-modalstatic/index";
import animateMain from "./sections/jky-animate/index";
import PhotovolaticFindOut from './sections/jky-ces-videos/index'

window.zModal = ZModle

$(document).ready(function() {
    animateMain()
    jkyForm();
    JKYmodalstatic();
    new PhotovolaticFindOut({
        pcEl: ".findout-pc-swiper",
        mbEl: ".findout-mb-swiper",
    })
})
